
import { supabase } from '@/lib/supabase';

export interface SymbolData {
  value: string;
  label: string;
  category: string;
}

export class SymbolService {
  static async getAvailableSymbols(): Promise<{ success: boolean; data?: SymbolData[]; error?: string }> {
    try {
      console.log('Fetching available symbols from tradingview_signals_data...');
      
      const { data, error } = await supabase
        .from('tradingview_signals_data')
        .select('symbol')
        .order('symbol');

      if (error) {
        console.error('Error fetching symbols:', error);
        return { success: false, error: error.message };
      }

      if (!data || data.length === 0) {
        console.log('No symbols found in database');
        return { success: false, error: 'No symbols found' };
      }

      // Get unique symbols and categorize them
      const uniqueSymbols = [...new Set(data.map(item => item.symbol))];
      const symbolsData: SymbolData[] = uniqueSymbols.map(symbol => ({
        value: symbol,
        label: symbol,
        category: this.categorizeSymbol(symbol)
      }));

      console.log(`Found ${symbolsData.length} unique symbols:`, symbolsData.map(s => s.value));
      return { success: true, data: symbolsData };
    } catch (error) {
      console.error('Error in getAvailableSymbols:', error);
      return { success: false, error: error instanceof Error ? error.message : 'Unknown error' };
    }
  }

  static async getAvailableSymbolsFromIdeas(): Promise<{ success: boolean; data?: SymbolData[]; error?: string }> {
    try {
      console.log('Fetching available symbols from tradingview_ideas...');
      
      const { data, error } = await supabase
        .from('tradingview_ideas')
        .select('symbol')
        .order('symbol');

      if (error) {
        console.error('Error fetching symbols from ideas:', error);
        return { success: false, error: error.message };
      }

      if (!data || data.length === 0) {
        console.log('No symbols found in tradingview_ideas');
        return { success: false, error: 'No symbols found' };
      }

      // Get unique symbols and categorize them
      const uniqueSymbols = [...new Set(data.map(item => item.symbol))];
      const symbolsData: SymbolData[] = uniqueSymbols.map(symbol => ({
        value: symbol,
        label: symbol,
        category: this.categorizeSymbol(symbol)
      }));

      console.log(`Found ${symbolsData.length} unique symbols from ideas:`, symbolsData.map(s => s.value));
      return { success: true, data: symbolsData };
    } catch (error) {
      console.error('Error in getAvailableSymbolsFromIdeas:', error);
      return { success: false, error: error instanceof Error ? error.message : 'Unknown error' };
    }
  }

  private static categorizeSymbol(symbol: string): string {
    if (symbol.includes('BTC') || symbol.includes('ETH') || symbol.includes('ADA')) {
      return 'Crypto';
    }
    if (symbol.includes('XAU') || symbol.includes('XAG')) {
      return 'Commodities';
    }
    if (symbol.includes('USD') || symbol.includes('EUR') || symbol.includes('GBP')) {
      return 'Forex';
    }
    return 'Other';
  }
}
